﻿function showContent(id, event) {
    let element = document.getElementById(id);
    if (!element) return;
    element.classList.remove('hidden');
    event?.preventDefault();
}

function hideContent(id, event) {
    let element = document.getElementById(id);
    if (!element) return;
    element.classList.add('hidden');
    event?.preventDefault();
}

function toggleContent(id, event) {
    let element = document.getElementById(id);
    if (!element) return;

    if (element.classList.contains('hidden')) {
        showContent(id, event);
    } else {
        hideContent(id, event);
    }
}

function rotateArrow(id) {
    let arrow = document.getElementById(id);
    if (!arrow) return;

    if (arrow.style.transform) {
        arrow.style.removeProperty('transform');
    } else {
        arrow.style.transform = 'rotate(270deg)';
    }
}